import { Component } from "react";
import history from "../history";
import donate_barcode from "../assets/images/donate_barcode.avif";

interface Props {}

interface State {
  others: number;
  emptyamount: boolean;
  isemptyemail: boolean;
  isLoading: boolean;
}

export class Donation extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      others: 0,
      emptyamount: false,
      isemptyemail: false,
      isLoading: false,
    };
  }

  componentDidMount() {}
  backtotemple = () => {
    history.push(`/Index`);
  };

  DonateSubmit = async () => {
    this.setState({ isLoading: true });

    let Donate = this.state.others;

    if (Donate > 0) {
      var url =
        "https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=" +
        this.state.others +
        "&currency_code=USD";
      var win = window.open(url, "_blank");
      win.focus();
    } else {
      this.setState({ isemptyemail: true });
      return false;
    }
    this.setState({ isLoading: false });
  };

  handleotherAmount = (event) => {
    this.setState({ others: event.target.value, emptyamount: false });
  };

  render() {
    const { emptyamount, isemptyemail, isLoading } = this.state;
    return (
          <div className="bg">
            <div className={isLoading ? "show" : "fade"}>
              <div className="loading-spinner"></div>
            </div>
              <div className="col-md-12  contribute-header">
                <div className="contribute-header-text">CONTRIBUTE</div>
              </div>
              <div className="donation-modal-content mt-3">
                <img src={donate_barcode} width={"200px"} height={200} />
                <p className="mt-3 font-bold" style={{ overflowWrap: "break-word" }}>
                  Zelle ID:
                </p>
                <a className="mt-1 font-bold cursor-pointer" style={{ overflowWrap: "break-word" }}>
                  donate2htcc@hindutempleofcolorado.net
                </a>
                <h3 className="donate-footer-text mt-3">
                Thank you for your generosity.
              </h3>
              </div>
            {/* <div className="hide-mt-10 donation-container">
                            <div className="row">
                                <div className="d-flex justify-content-center donate-btn1">

                                    <a className="col-sm-1" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=10&currency_code=USD"} target="blank"><button className="golden-btn">$10</button></a>
                                    <a className="col-sm-1" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=25&currency_code=USD"} target="blank"><button className="golden-btn">$25</button></a>
                                    <a className="col-sm-1" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=50&currency_code=USD"} target="blank"><button className="golden-btn">$50</button></a>
                                    <a className="col-sm-1" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=100&currency_code=USD"} target="blank"><button className="golden-btn">$100</button></a>
                                    <a className="col-sm-1" href={"https://www.paypal.com/cgi-bin/webscr/business=donations%40hindutempleofcolorado.org&cmd=_donations&item_name=Donation&item_number=&amount=" + this.state.others + "&currency_code=USD" + JSON.stringify(this.state.others)}><button className="golden-btn other-btn">Other</button></a>
                                </div>
                            </div>
                            <div className="row">
                                <a className="col-sm-2 donate-field"><input type="number" name="HPR" min="0" step="0.01" placeholder="$" required onChange={this.handleotherAmount} /></a>{"   "}
                                <span className={(isemptyemail ? 'general-message-donate' : 'hide')}>Enter a valid Amount.</span>
                                <a className="col-sm-3" ><button className="golden-btn golden-submit-btn" onClick={() => this.DonateSubmit()}>Submit</button></a>

                            </div>
                        </div> */}
           
      </div>
    );
  }
}
